export enum MUTATION_TYPES {
  SET_MOBILE_MENU_VISIBILITY = 'setMobileMenuVisibility',
}
